@if (country && formGroup) {
  <div class="form-section-head">
    <h2>{{ country }} Recyclability</h2>
  </div>

  <div class="country-recyclability-message">
    <span
      >{{ translationService.getEnterRecyclabilityStatusText(country) }}
    </span>
  </div>

  @if (countryRecyclabilityInfo) {
    <div class="recyclability-statuses custom-form-row">
      @for (
        status of countryRecyclabilityInfo.recyclabilityStatuses;
        track status
      ) {
        <div class="recyclability-status">
          <span>{{ status.foreignName }}</span>
          <img
            class="recyclability-img"
            [ngSrc]="status.symbolPath"
            height="120"
            width="120"
            [alt]="translationService.getRecyclableText()"
          />
          <span>{{ status.localName }}</span>
        </div>
      }
    </div>

    <div class="country-detail-container" [formGroup]="formGroup">
      <p>
        {{
          translationService.getSelectProductCountryRecyclabilityStatusText()
        }}
        <span class="country-name">{{ country }}</span>
      </p>
      <mat-radio-group
        aria-labelledby="recyclabilityStatusRadioGroup"
        formControlName="recyclabilityStatus"
      >
        @for (
          status of countryRecyclabilityInfo.recyclabilityStatuses;
          track status
        ) {
          <mat-radio-button [value]="status.name">{{
            status.name
          }}</mat-radio-button>
        }
      </mat-radio-group>

      @if (submitted && formGroup.get('recyclabilityStatus')?.invalid) {
        <mat-error>{{
          translationService.getSelectRecyclabilityOptionText()
        }}</mat-error>
      }
    </div>
  }
}
